import {combineReducers} from 'redux';
import {getUsersReducer} from './getUsers'
import {updateLawRed } from './updateLawREd';
import {getLawDocsDetailReducer} from '../../../documentDetail/store/reducers/getLawDocsDetail'
const reducer = combineReducers({
   updateLawRed,getUsersReducer,getLawDocsDetailReducer 
    });
    
    export default reducer;
